import { useLocales } from '@shared/locales'
import { DatePicker, Form, message, Modal, Radio } from 'antd'
import { useState } from 'react'

import { ActionsType } from './types'

type GenerationType = 'contract' | 'attachment'

export const GenerateContract = ({ onSuccess, ...props }: ActionsType) => {
  const { t } = useLocales()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      setLoading(true)

      // Demo: Simulate contract/attachment generation
      setTimeout(() => {
        setLoading(false)
        const type = values.type as GenerationType
        const messageText =
          type === 'contract'
            ? t('contracts.contract_generated') ||
              'Contract generated successfully'
            : t('contracts.attachment_generated') ||
              'Attachment generated successfully'
        message.success(messageText)
        onSuccess?.()
        form.resetFields()
        props.onCancel?.()
      }, 1000)
    } catch (error) {
      // Form validation failed
    }
  }

  return (
    <Modal
      width={600}
      maskClosable={false}
      title={t('contracts.generate_contract') || 'Generate Contract'}
      cancelText={t('buttons.cancel')}
      okText={t('buttons.generate') || 'Generate'}
      onOk={handleOk}
      confirmLoading={loading}
      {...props}
    >
      <Form form={form} layout="vertical" initialValues={{ type: 'contract' }}>
        <Form.Item
          name="type"
          label={t('contracts.generation_type') || 'Type'}
          rules={[{ required: true }]}
        >
          <Radio.Group>
            <Radio value="contract">
              {t('contracts.generate_contract') || 'Generate Contract'}
            </Radio>
            <Radio value="attachment">
              {t('contracts.generate_attachment') || 'Generate Attachment'}
            </Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="deadline_at"
          label={t('contracts.deadline') || 'Deadline'}
          rules={[
            {
              required: true,
              message:
                t('contracts.deadline_required') || 'Please select a deadline'
            }
          ]}
        >
          <DatePicker
            style={{ width: '100%' }}
            placeholder={t('contracts.deadline') || 'Select deadline'}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
